export const setContentSquare = () => {
  window._uxa = window._uxa || [];
  // We need to revisit this to check how we can take these urls from env config.
  const prodCsURL = '//t.contentsquare.net/uxa/c907c711d1ec2.js';
  const lowerEnvCsURL = '//t.contentsquare.net/uxa/ea5eea11668f5.js';

  try {
    if (typeof dataLayer !== 'undefined') {
    }
  } catch (err) {
    err.message = `PROBLEM IN CONTENT SQUARE SCRIPT ${err.message}`;
    console.error(err);
  }
  if (typeof CS_CONF === 'undefined') {
    window._uxa.push([
      'setPath',
      window.location.pathname + window.location.hash.replace('#', '?__')
    ]);
    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.async = true;
    scriptTag.src = process.env.NODE_ENV !== 'production' ? lowerEnvCsURL : prodCsURL;
    document.getElementsByTagName('head')[0].appendChild(scriptTag);
  } else {
    window._uxa.push([
      'trackPageview',
      window.location.pathname + window.location.hash.replace('#', '?__')
    ]);
  }
};
